<template>
  <div>
    <FilterRenovaciones
      @searchUpdated="getRenovacionesPendientes($event)"
      :loading="loading"
    />
    <TableRenovaciones
      :emisiones="emisiones"
      :loading="loading"
      :totalItems="totalItems"
      :pagination="pagination"
      @update:pagination="updatePagination"
    />
    <div class="pt-5">
      <v-row dense justify="end">
        <v-col cols="auto">
          <v-tooltip bottom :disabled="totalItems > 0">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn
                  class="common-botton"
                  dark
                  min-width="120"
                  @click="accionarRenovacion"
                  :disabled="totalItems == 0 || loading"
                  :loading="loading"
                >
                  Renovar pendientes
                </v-btn>
              </div>
            </template>
            <span
              >No hay renovaciones pendientes para la fecha seleccionada</span
            >
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import FilterRenovaciones from "@/components/renovaciones/FilterRenovaciones.vue";
import TableRenovaciones from "@/components/renovaciones/TableRenovaciones.vue";
import { obtenerRenovacionesPendientes } from "@/services/renovacionService";
import { accionarRenovaciones } from "@/services/renovacionService";

export default {
  components: {
    FilterRenovaciones,
    TableRenovaciones,
  },
  data() {
    return {
      currentForm: {},
      emisiones: [],
      loading: false,
      totalItems: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  methods: {
    async getRenovacionesPendientes(form) {
      if (form) {
        this.currentForm = form;
        this.pagination.page = 1;
      }

      this.loading = true;

      try {
        const payload = {
          ...this.currentForm,
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage,
        };

        const res = await obtenerRenovacionesPendientes(payload);

        if (res.status === 200) {
          this.emisiones = res.data.data;
          this.totalItems = res.data.total;

          if (this.totalItems === 0) {
            this.$toast.info(
              "No hay renovaciones pendientes para la fecha seleccionada.",
            );
          }
        } else {
          this.$toast.info(res.data.message);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          "Ocurrió un error al obtener las renovaciones pendientes",
        );
      } finally {
        this.loading = false;
      }
    },

    updatePagination(pagination) {
      this.pagination = { ...pagination };
      this.getRenovacionesPendientes();
    },

    async accionarRenovacion() {
      this.loading = true;

      try {
        const payload = {
          ...this.currentForm,
        };
        const res = await accionarRenovaciones(payload);
        if (res.status == 200)
          this.$toast.success(
            "Las emisiones se encuentran en proceso de renovación.",
          );
        else this.$toast.error("Ocurrió un error al renovar las emisiones.");
      } catch (error) {
        console.error(error);
        this.$toast.error("Ocurrió un error al renovar las emisiones");
      } finally {
        this.emisiones = [];
        this.totalItems = 0;
        this.pagination.page = 1;
        this.loading = false;
      }
    },
  },
};
</script>
